export default __webpack_public_path__ + "static/media/37-PurpleHaze.c7de3e72.jpeg";